import { render } from "./Zagazig University Hospital.vue?vue&type=template&id=3dfd93a6&scoped=true"
const script = {}

import "./Zagazig University Hospital.vue?vue&type=style&index=0&id=3dfd93a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3dfd93a6"

export default script